import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-2 mt-1.5" }
const _hoisted_2 = { class: "ml-2 text-xs text-gray-lp-300 font-semibold" }
const _hoisted_3 = { class: "text-10px text-gray-lp-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock(_component_DataWrapper, {
    label: "Diskon",
    class: "w-full",
    "data-testid": "price-type-form-discount-section"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Toggle, {
          modelValue: _ctx.isDiscount,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDiscount = $event)),
          "custom-label": true,
          "data-testid": "price-type-form-client-discount-config-toggle"
        }, {
          "custom-label": _withCtx(() => [
            _createVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.discountToggle')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.discountToggleDescription')), 1)
      ])
    ]),
    _: 1
  }))
}